import { useEffect, useState } from 'react';
import { useContent } from '../hooks/useContent';
import './WorkingOff.css';

const HASH_TO_TAB = {
  '#working-off-bachelor': 'bachelor',
  '#working-off-magistracy': 'magistracy',
  '#working-off-doctoral': 'doctoral',
  '#working-off-payment': 'payment',
};

export default function WorkingOff() {
  const { WORKING_OFF_ITEMS, ui } = useContent();
  const wo = ui.workingOff;
  const [activeId, setActiveId] = useState(WORKING_OFF_ITEMS[0]?.id || 'bachelor');
  const activeItem = WORKING_OFF_ITEMS.find((item) => item.id === activeId) || WORKING_OFF_ITEMS[0];

  useEffect(() => {
    const syncFromHash = () => {
      const nextId = HASH_TO_TAB[window.location.hash];
      if (nextId) {
        setActiveId(nextId);
        document.getElementById('working-off')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    syncFromHash();
    window.addEventListener('hashchange', syncFromHash);

    return () => window.removeEventListener('hashchange', syncFromHash);
  }, []);

  const handleCardClick = (itemId) => {
    setActiveId(itemId);
    window.history.replaceState(null, '', `#working-off-${itemId}`);
  };

  return (
    <section id="working-off" className="working-off">
      <div className="section">
        <div className="section-label">{wo.label}</div>
        <h2 className="section-title">{wo.title}</h2>
        <p className="section-subtitle working-off-subtitle">{wo.subtitle}</p>

        <div className="working-off-grid">
          {WORKING_OFF_ITEMS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`working-off-card ${activeId === item.id ? 'working-off-card--active' : ''}`}
              onClick={() => handleCardClick(item.id)}
              aria-pressed={activeId === item.id}
            >
              <span>{item.label}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 6l6 6-6 6" />
              </svg>
            </button>
          ))}
        </div>

        <div className="working-off-details">
          <div className="working-off-details__badge">{activeItem.badge}</div>
          <h3 className="working-off-details__title">{activeItem.title}</h3>
          <p className="working-off-details__text">{activeItem.description}</p>

          {activeItem.sections && activeItem.sections.map((section, si) => (
            <div key={si} className="working-off-details__block">
              {section.heading && <div className="working-off-details__caption">{section.heading}</div>}
              <ul className="working-off-details__list">
                {section.points.map((point, pi) => (
                  <li key={pi}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
